// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"75aa4be5","641":"2e949d77"}[chunkId] + ".chunk.css";
};